import { ApiMethodSignature, ApiModel, ApiModelVersion } from 'types/swagger/clarifai-api';

/**
 * Check if model version is selected and has method signature or pick it directly from model object.
 */
export const getModelSignaturesFromModelVersion = (modelVersion?: ApiModelVersion, model?: ApiModel) => {
  const method_signatures = modelVersion?.id ? modelVersion?.method_signatures ?? undefined : model?.model_version?.method_signatures ?? undefined;
  return method_signatures as ApiMethodSignature[] | undefined;
};
